import {FaSlack} from "react-icons/fa";
import {FiCode, FiMail, FiMessageSquare, FiRss} from "react-icons/fi";
import {SubscriptionType} from "../types/statuspages";

export const TAB_ICONS: Record<SubscriptionType, React.ComponentType<{size?: number; className?: string}>> = {
  EMAIL: FiMail,
  SLACK: FaSlack,
  RSS: FiRss,
  SMS: FiMessageSquare,
  WEBHOOK: FiCode,
};

export const TAB_LABELS: Record<SubscriptionType, string> = {
  EMAIL: "Email",
  SLACK: "Slack",
  RSS: "RSS",
  SMS: "SMS",
  WEBHOOK: "Webhook",
};

export const SUCCESS_MESSAGES: Record<SubscriptionType, string> = {
  EMAIL: "Thanks! Please check your inbox and confirm your subscription.",
  SLACK: "Thanks! Your Slack workspace will receive status updates.",
  RSS: "RSS URL copied to clipboard!",
  SMS: "Thanks! You will receive a text message to confirm your subscription.",
  WEBHOOK: "Thanks! Your webhook will receive status updates.",
};
